<template>
  <div :class="[`o-edition-section-info o-edition-section-info-${section}`,
      ($store.getters.getAcademyData.persona === undefined && $store.getters.getAcademyData.is_licencia_paga) ||
      ($store.getters.getAcademyDaysLeft !== null && !$store.getters.getAcademyData.is_licencia_paga)
        ? 'o-edition-section-info-upgrade' : ''
    ]">
    <span
      v-if="showLoadingState >= 4"
      class="m-edition-section-info-menu"
    >
      <span v-if="!showElementName">
        <span class="section-icon">
          <i :class="[`${iconClass}`, 'margin-right-medium']"></i>
        </span>
        <span class="margin-right-small">{{ $t(`mEditionInfo.${$route.meta.isEdition}`) }}</span>
      </span>
      <span v-else>
        <span class="section-icon">
          <i :class="[`${iconClass}`, 'margin-right-medium']"></i>
        </span>
        <span class="margin-right-small">{{ elementName }}</span>
      </span>

      <a
        v-show="goBackText"
        class="go-back-text"
        href="#"
        @click.prevent="$router.go(-1)"
      >
        <i class="far fa-chevron-left font-size-xsmall margin-right-xsmall"></i>
        {{ goBackText }}
      </a>
    </span>
  </div>
</template>

<script>
// TODO: Colocar información de item y subitem navegados en versión mobile

export default {
  name: 'OrganismEditionSectionInfo',

  props: {
    elementName: String,
    goBackText: String,
    infoTitle: String,
    infoSubTitle: String,
    showLoadingState: Number,
    subject: String
  },

  data () {
    return {
      sectionIcons: {
        academy: 'fas fa-school',
        account: 'fas fa-user',
        asset: 'fas fa-clipboard-list',
        billing: 'fas fa-credit-card',
        map: 'fas fa-map-marker-alt',
        product: 'fas fa-box-open'
      }
    }
  },

  computed: {
    iconClass () {
      return this.sectionIcons[this.$route.meta.isEdition]
    },

    section () {
      return this.$route.meta.isEdition
    },

    showElementName () {
      return this.$route.meta.isEdition === 'asset' || this.$route.meta.isEdition === 'product' || this.$route.meta.isEdition === 'map'
    }
  }
}
</script>
